export class ResetPassword {
  Email: string;
  Code: string;
  Password: string;
  ConfirmPassword: string;

  constructor() {
    this.Email = null;
    this.Code = null;
    this.Password = null;
    this.ConfirmPassword = null;
  }
}
